import { useSelector, TypedUseSelectorHook } from 'react-redux';
import IStore from 'types/storeTypes';

export const useAppSelector: TypedUseSelectorHook<IStore> = useSelector;
